<template>
  <!-- Any way of closing it that is not one of the two buttons — a click
       outside, Esc — is a cancel. The dialog stays whatever `visible` says. -->
  <v-dialog :model-value="visible" :max-width="plate ? 440 : 350" @update:model-value="open => open || $emit('cancel')">
    <!-- Seaded -> Dialoogid uues kujunduses: says what is about to happen to
         what, and the button is the act itself (Kustuta objekt), not Jah. -->
    <div v-if="plate" class="dlg" role="alertdialog" :aria-label="heading || title">
      <div class="dlg-cf">
        <span class="dlg-cf-ic" :class="{ 'dlg-cf-ic--ok': !danger }" aria-hidden="true">
          <v-icon size="20">{{ danger ? 'mdi-delete-outline' : 'mdi-swap-horizontal' }}</v-icon>
        </span>
        <div>
          <h3>{{ heading || title }}</h3>
          <div v-if="text" class="dlg-cf-text">{{ text }}</div>
          <div v-if="$slots.default" class="dlg-cf-text"><slot /></div>
          <div v-if="detail" class="dlg-what">{{ detail }}<small v-if="detailSub">{{ detailSub }}</small></div>
        </div>
      </div>
      <div class="dlg-cf-foot">
        <button type="button" class="dlg-btn dlg-btn--ghost" @click="$emit('cancel')">{{ cancelTitle === 'Ei' ? 'Loobu' : cancelTitle }}</button>
        <button type="button" class="dlg-btn" :class="{ 'dlg-btn--danger': danger }" @click="$emit('confirm')">{{ actionText }}</button>
      </div>
    </div>
    <v-card v-else>
      <v-card-title class="text-h5">{{title}}</v-card-title>
      <v-card-text><slot /></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('confirm')" color="green-darken-1" variant="text">
          {{confirmTitle}}
        </v-btn>
        <v-btn @click="$emit('cancel')" color="black" variant="text">
          {{cancelTitle}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import '@/styles/dialog-plate.css'

export default {
  emits: ['confirm', 'cancel'],
  props: {
    visible: {
      required: true,
      default: false
    },
    title: {
      required: false,
      default: 'Oled sa kindel?'
    },
    confirmTitle: {
      required: false,
      default: 'Jah'
    },
    cancelTitle: {
      required: false,
      default: 'Ei'
    },
    // The new look only, so the old one stays word for word: its own title
    // and sentence, the button's words (Kustuta objekt), whether it is a red
    // one, and what it is about to act on.
    heading: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    danger: {
      type: Boolean,
      default: true
    },
    detail: {
      type: String,
      default: ''
    },
    detailSub: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['features']),
    plate () {
      return !!(this.features && this.features.dialogPlate)
    },
    actionText () {
      if (this.action) return this.action
      return this.confirmTitle === 'Jah' ? 'Jah, jätka' : this.confirmTitle
    }
  }
}
</script>
